<template>
  <div id="convert-csv">
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>
<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'ConvertCsv',
  components: {
    HelloWorld
  }
}
</script>

<style>
body{
  margin: 0;
}
</style>
